import React, {useDebugValue} from 'react';

import classNames from 'classnames';

import {Button as ButtonDefault, ButtonPrimary} from '@homeaway/react-buttons';

import {useSearchFormContext} from '../../../hooks';
import {undef, hasCheckAvailabilitySubmitActionType} from '../../../utils';

import {SearchIcon} from '../../SearchIcon';

const classNamespace = 'search-form';
const fieldClassName = `${classNamespace}__field`;
const buttonFieldClassName = `${classNamespace}__button-field`;
const submitButtonFieldClassName = `${classNamespace}__submit-button-field`;

// eslint-disable-next-line complexity
function useComponent() {
    const {
        form: {
            options: {
                showIcons
            },
            settings: {
                hasLoaded,
                isSubmitting
            }
        },
        submit,
        submit: {
            events: {
                onClick
            },
            options: {
                iconName,
                isPrimaryAction,
                showIcon
            },
            settings: {},
            translations: {
                checkAvailabilityLabelText,
                searchLabelText
            }
        }
    } = useSearchFormContext();

    const Button = isPrimaryAction ? ButtonPrimary : ButtonDefault;

    const className = classNames(fieldClassName, buttonFieldClassName, submitButtonFieldClassName);

    const type = 'submit';

    const labelIcon = (showIcon || showIcons && showIcon === undef) && (
        <SearchIcon iconName={iconName}/>
    ) || null;

    const labelText = (
        hasCheckAvailabilitySubmitActionType(submit)
            ? checkAvailabilityLabelText
            : searchLabelText
    );

    const label = (
        <>
            {labelIcon}
            <span>{labelText}</span>
        </>
    );

    const disabled = !hasLoaded || isSubmitting;
    const loading = hasLoaded && isSubmitting;

    function handleClick(...args) {
        onClick(...args);
    }

    const result = {
        Button,
        className,
        type,
        label,
        disabled,
        loading,
        onClick: handleClick
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
